export const reasonToDescription = {
  "missing-local-user-mapping":
    "Dein Konto ist angemeldet, aber es ist noch kein lokaler App-Benutzer verknuepft.",
  "missing-access-token":
    "Die Anmeldung war erfolgreich, aber es konnte kein Zugriffstoken fuer die App verwendet werden.",
  "access-denied":
    "Dein Konto ist nicht fuer den Zugriff auf diese Anwendung berechtigt.",
  forbidden:
    "Dein Konto ist authentifiziert, aber es fehlen die erforderlichen Berechtigungen.",
  unknown: "Der Zugriff auf diese Anwendung wurde verweigert.",
} as const;

export type NoAccessReason = keyof typeof reasonToDescription;
